import { Component, OnDestroy, OnInit } from '@angular/core';
import { ConvertHelper } from '@barthauer/abc/core';
import { ObjectTypeInfo } from '@barthauer/abc/core/data';
import { ResourceManagerService, ResourceSet } from '@barthauer/abc/core/resources';
import { ColumnTypeIcon, CoreService, FilterOption } from '@barthauer/abc/queries/opath/core';
import { ValueChangedEvent } from 'devextreme/ui/text_box';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AbcQueriesEditorService } from '../../../abc-queries-editor.service';
import { SelectObjectTypeTranslation } from '../../../viewModels/abc-queries-editor.viewModel';

@Component({
    selector: 'abc-opath-queries-editor-select-object-type',
    templateUrl: './select-object-type.component.html',
    styleUrls: ['./select-object-type.component.scss'],
    standalone: false
})
export class SelectObjectTypeComponent implements OnInit, OnDestroy {
  public objectTypeInfos: ObjectTypeInfo[] = [];
  public objectTypeInfosBackup: ObjectTypeInfo[] = [];
  public loading: boolean;
  public ColumnTypeIcon = ColumnTypeIcon;
  public searchTerm: string = '';
  public currentFilterOption: FilterOption;
  public resAsync: Promise<ResourceSet>;

  private unsubscribe$ = new Subject<void>();
  constructor(
    private coreService: CoreService,
    private abcQueriesEditorService: AbcQueriesEditorService,
    private resourcesService: ResourceManagerService
  ) {
    this.resAsync = this.resourcesService.getResourceSet('abc-opath-queries-editor');
  }

  public translation: SelectObjectTypeTranslation;

  async ngOnInit(): Promise<void> {
    const res = await this.resAsync;

    this.translation = {
      title: res.get('selectObjectType-title'),
      description: res.get('selectObjectType-description'),
      loadingMessage: res.get('selectObjectType-loading'),
    };
    this.getObjectTypeInfos();
  }

  public getObjectTypeInfos() {
    if (this.abcQueriesEditorService.objectTypeInfosCacheMap.has(this.abcQueriesEditorService.objectSpaceName)) {
      this.objectTypeInfos = this.abcQueriesEditorService.objectTypeInfosCacheMap.get(
        this.abcQueriesEditorService.objectSpaceName
      );
      this.abcQueriesEditorService.objectTypeInfos = this.objectTypeInfos;
      this.objectTypeInfosBackup = this.objectTypeInfos;
    } else {
      this.loading = true;
      this.abcQueriesEditorService
        .getObjectTypeInfos()
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((objectTypeInfos: ArrayBuffer) => {
          this.loading = false;
          this.objectTypeInfos = ConvertHelper.arrayBufferToObjectArray(objectTypeInfos);
          this.abcQueriesEditorService.objectTypeInfos = this.objectTypeInfos;
          this.objectTypeInfosBackup = this.objectTypeInfos;

          this.abcQueriesEditorService.objectTypeInfosCacheMap.set(
            this.abcQueriesEditorService.objectSpaceName,
            this.objectTypeInfos
          );
        });
    }
  }

  public filter(event: ValueChangedEvent) {
    this.objectTypeInfosBackup = this.objectTypeInfos.filter((objectTypeInfo: ObjectTypeInfo) =>
      new RegExp(event.value, 'i').test(objectTypeInfo.DisplayText)
    );
  }

  public searchTermChanged(searchTerm: string): void {
    this.searchTerm = searchTerm;
  }

  public filterOptionChanged(filterOption: FilterOption): void {
    this.currentFilterOption = filterOption;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
